import React, { useState } from 'react';
import { Page, Text, Document, StyleSheet, View, Image } from '@react-pdf/renderer';
import localStorage from 'utils/localStorage';
import Auth from 'shared/Auth';
import get from 'lodash/get';
import PdfFieldProcessor from './PdfFieldProcessor';
const PRIMARY_ORANGE = '#f06024';
const PRIMARY_BLUE = '#153b62';
const ResponsesDownload = props => {
  const { sections, responses } = props;
  const titleMap = {
    en_US: 'title',
    fr_FR: 'title_fr',
  };

  const currentLanguage = get(Auth.getLanguage(), 'lang');

  const titleKey = get(titleMap, currentLanguage);
  const processQuestion = (questionDef, index, parentLink = false) => {
    const questions = get(questionDef, 'questions');

    const baseQuestion =
      get(questionDef, 'question_type') === 'multiple_questions' ? (
        <View key={`${index}-${get(questionDef, titleKey)}`}>
          {parentLink ? (
            <Text style={styles.question}> {get(questionDef, titleKey)}</Text>
          ) : (
            <View>
              <Text style={styles.question}>{get(questionDef, titleKey)}</Text>
            </View>
          )}
          <View>
            {questions.map((questionItem, qnIndex) => processQuestion(questionItem, qnIndex))}
          </View>
        </View>
      ) : (
        <View className="question-list__item" key={`${index}-${get(questionDef, titleKey)}`}>
          <View className="question-list__item__question">
            <Text style={styles.question}>{get(questionDef, titleKey)}</Text>
          </View>
          {questions && questions.length ? (
            questions.map((questionItem, qnIndex) => processQuestion(questionItem, qnIndex))
          ) : (
            <PdfFieldProcessor
              titleKey={titleKey}
              valueKey="value"
              responses={responses}
              question={questionDef}
            />
          )}
        </View>
      );

    return baseQuestion;
  };

  return (
    <Document>
      <Page style={styles.body} wrap>
        <Text style={styles.header}>Question Responses</Text>
        {sections.length
          ? sections.map(quiz => (
              <View key={quiz.id}>
                <Text style={styles.subtitle}>{get(quiz, titleKey)}</Text>
                {get(quiz, 'questions').map((questionDef, index) =>
                  processQuestion(questionDef, index, true)
                )}
              </View>
            ))
          : ''}
      </Page>
    </Document>
  );
};

export default ResponsesDownload;

const styles = StyleSheet.create({
  body: {
    paddingTop: 35,
    paddingBottom: 65,
    paddingHorizontal: 35,
  },
  title: {
    fontSize: 18,
    textAlign: 'center',
  },
  author: {
    fontSize: 12,
    textAlign: 'center',
    marginBottom: 40,
  },
  subtitle: {
    fontSize: 18,
    margin: 12,
    textAlign: 'center',
  },
  text: {
    margin: 12,
    fontSize: 14,
    textAlign: 'justify',
    fontFamily: 'Times-Roman',
    color: '#000',
  },
  question: {
    color: '#363636',
    fontSize: 16,
    marginBottom: 10,
    textAlign: 'justify',
    fontFamily: 'Times-Roman',
    paddingBottom: '1rem',
  },
  questionTitle: {
    color: PRIMARY_BLUE,
    borderBottomColor: PRIMARY_ORANGE,
    borderBottomWidht: 1,
  },
  image: {
    marginVertical: 15,
    marginHorizontal: 100,
  },
  header: {
    fontSize: 14,
    marginBottom: 20,
    textAlign: 'center',
    fontWeight: 'bold',
  },
});



// WEBPACK FOOTER //
// ./src/components/CDRSections/Responses/ResponsesDownload/index.js